import { ToggleButton } from "primereact/togglebutton";
import * as React from "react";
import { useTranslation } from "react-i18next";

const PrwToggleButton = (props: any) => {
  let { options, ...restProps } = props;
  const { t } = useTranslation();

  // Defaut Values
  options["onLabel"] = options["onLabel"] ?? t("generic.label.yes");
  options["offLabel"] = options["offLabel"] ?? t("generic.label.no");
  options["onIcon"] = options["onIcon"] ?? "pi pi-check";
  options["offIcon"] = options["offIcon"] ?? "pi pi-times";

  return (
    <div>
      <ToggleButton
        onLabel={options.onLabel}
        offLabel={options.offLabel}
        onIcon={options.onIcon}
        offIcon={options.offIcon}
        checked={restProps.value}
        onChange={(e: any) => {
          restProps.onChange(e.value);
        }}
        className="px-2 py-1"
      />
    </div>
  );
};

export default PrwToggleButton;
